var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 140,
    viewBox: "0 0 165 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LV2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M113.327 96V88.6981C115.233 86.8385 117.084 85.0062 118.881 83.2012C120.732 81.3963 122.475 79.646 124.108 77.9505C126.722 75.3251 128.873 72.9185 130.561 70.7306C132.303 68.5428 133.61 66.3824 134.481 64.2492C135.352 62.0614 135.788 59.7368 135.788 57.2755C135.788 54.1032 135.026 51.6419 133.501 49.8916C132.031 48.1414 130.016 47.2663 127.457 47.2663C127.13 47.2663 126.776 47.2663 126.395 47.2663C126.068 47.2663 125.742 47.2936 125.415 47.3483L124.353 53.1734C123.972 56.0175 123.182 57.9045 121.985 58.8344C120.787 59.7095 119.561 60.1471 118.309 60.1471C117.166 60.1471 116.104 59.8462 115.124 59.2446C114.198 58.6429 113.49 57.8225 113 56.7833C113.109 53.775 114.035 51.259 115.777 49.2353C117.52 47.1569 119.806 45.598 122.638 44.5588C125.469 43.5196 128.573 43 131.949 43C135.924 43 139.137 43.629 141.587 44.887C144.092 46.145 145.943 47.8406 147.141 49.9737C148.339 52.1068 148.938 54.5134 148.938 57.1935C148.938 59.8189 148.258 62.3622 146.896 64.8235C145.535 67.2848 143.411 69.8008 140.525 72.3715C137.639 74.9422 133.937 77.7864 129.417 80.904C128.328 81.6698 127.185 82.4628 125.987 83.2833C124.789 84.1037 123.564 84.9788 122.311 85.9087H150V96H113.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91.6106 47.08V43H108.971V47.32L102.971 48.28L86.4906 95.72H78.7306L61.5306 47.8L56.8906 47.32V43H82.6506V47.08L75.8506 47.96L86.8106 80.92L97.8506 48.12L91.6106 47.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 47.32V43H47.4V47.32L40.76 47.96C40.7067 51.2133 40.6533 54.52 40.6 57.88C40.6 61.1867 40.6 64.4933 40.6 67.8V72.04C40.6 74.92 40.6 77.9867 40.6 81.24C40.6533 84.44 40.7067 87.6933 40.76 91H54.6L56.76 79.88H63.24L62.44 95.56H21V91.24L27 90.6C27.1067 87.3467 27.16 84.1733 27.16 81.08C27.16 77.9333 27.16 75.0533 27.16 72.44V67.8C27.16 64.4933 27.16 61.1867 27.16 57.88C27.16 54.52 27.1067 51.2133 27 47.96L21 47.32Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLv2);
export default __webpack_public_path__ + "static/media/lv2.4cca687de203956fa74d6688746e4f58.svg";
export { ForwardRef as ReactComponent };